import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../util/withRouter';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import withStyles from '@mui/styles/withStyles';
import Typography from '../../component/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import DataFormView from '../../component/form/v2/DataFormView';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../component/ErrorFallback';
import { joinDefined } from '../../util/strings';
import { buildTabDataFragment } from '../../util/functions';
import gql from 'graphql-tag';
import { ReferencePhoto } from '../funeral/FuneralFragments';
import ColumnLayout from '../../component/ColumnLayout';
import Grid from '../../component/form/Grid';
import { DiamondIcon, ExclamationCircleIcon, TickCircleIcon } from '../../component/IconIndex';
import GatedComponent from '../../component/GatedComponent';
import { InlineField } from '../../component/form/Inline';
import PrimaryButton from '../../component/form/PrimaryButton';
import SimpleValuableDetailsModal from '../mortuary/Common/SimpleValuableDetailsModal';
import { flattenConnection } from '../../util/graphql';
import { isNullOrUndefined } from '../../util/objects';
import NewTransferModal from './NewTransferModal';
import { ImageList, ImageListItem } from '../../component/form/ImageList';
import UploadFile, { getFileName } from '../../component/form/FileUpload';
import TransferlogTable from '../funeral/summary/TransferlogTable';

class TransfersActions extends Component {
    state = {
        loading: false,
        funeralID: null,
        isTransferModalOpen: false,
        openValuableModal: false,
        deleteValuableModal: false,
        valuableItemId: null
    };

    handleAddTransfer = () => {
        this.setState({ isTransferModalOpen: true });
    };

    onFileUploaded({ id, url, filename }) {
        const { form } = this.props;
        const DeceasedPhotos = form.getField('DeceasedPhotos') || [];

        DeceasedPhotos.push({
            ID: id,
            AbsoluteLink: url,
            Name: getFileName(filename)
        });

        form.setField({ DeceasedPhotos });
    }

    render() {
        const { classes, form } = this.props;
        const { isTransferModalOpen, openValuableModal, valuableItemId } = this.state;
        return (
            <Fragment>
                <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                    Transfers
                    <small className={classes.header}>
                        Actions:{' '}
                        {`${form.getState('LegacyKey')} ${joinDefined(
                            [form.getState('FirstName'), form.getState('MiddleName'), form.getState('Surname')],
                            ' '
                        )}`}
                    </small>
                </Typography>
                {!!form.loading ? (
                    <span className={classes.loading}>
                        <CircularProgress />
                    </span>
                ) : (
                    <Paper className={classes.paper} elevation={0}>
                        <ColumnLayout>
                            {this.renderLeftColumn()}
                            {this.renderRightColumn()}
                        </ColumnLayout>
                    </Paper>
                )}
                <SimpleValuableDetailsModal
                    open={openValuableModal}
                    onClose={() => this.setState({ openValuableModal: false, valuableItemId: null })}
                    context={this}
                    itemId={valuableItemId}
                    parentId={form.getState('ID')}
                    onCreateNew={this.onSaveValuable}
                    onSaved={this.onSaveValuable}
                />
                <NewTransferModal
                    funeralID={form.getField('ID')}
                    open={isTransferModalOpen}
                    onClose={() => this.setState({ isTransferModalOpen: false, funeralKey: null })}
                />
            </Fragment>
        );
    }

    renderLeftColumn() {
        const { classes, form } = this.props;
        const funeralID = form.getField('ID');
        return (
            <Grid container>
                <Grid bucket>
                    <Grid pc={1}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>History</span>
                        </Typography>
                        <PrimaryButton onClick={this.handleAddTransfer}>+ Add Transfer</PrimaryButton>
                    </Grid>
                    <Grid xs={12}>
                        <TransferlogTable funeralID={funeralID} />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderRightColumn() {
        return (
            <Grid container>
                {this.renderValuables()}
                {this.renderPhotos()}
            </Grid>
        );
    }

    renderValuables() {
        const { form, classes, locked } = this.props;
        const valuables = form ? form.getField('ValuableItems') : [];

        return (
            <Grid bucket={true}>
                <Grid pc={1}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>Valuables</span>
                    </Typography>
                    {(valuables && valuables.length > 0 && (
                        <Typography variant={'body1'} style={{ marginLeft: -4, marginRight: -4 }}>
                            {valuables.map((valuable, i) => {
                                const isDone = ['Placed', 'Returned', 'Received'].includes(valuable.CurrentLocation);
                                return (
                                    <span key={i} className={classes.listItems}>
                                        {isDone ? (
                                            <span
                                                className={classes.itemSigned}
                                                title={'Item is ' + valuable.CurrentLocation}
                                            >
                                                <TickCircleIcon className={classes.iconGood} />
                                            </span>
                                        ) : (
                                            <span className={classes.itemSigned} title="Item not received">
                                                <ExclamationCircleIcon className={classes.iconBad} />
                                            </span>
                                        )}
                                        {valuable.Description}
                                        <span className={classes.itemQty}>x{valuable.Quantity || 1}</span>
                                    </span>
                                );
                            })}
                        </Typography>
                    )) || <Typography variant={'body1'}>There are currently no valuables.</Typography>}
                </Grid>
                <InlineField>
                    {/*<PrimaryButton onClick={this.onClickAddValuable}>Add valuable...</PrimaryButton>*/}
                    {valuables && valuables.length > 0 ? (
                        <Fragment>
                            <PrimaryButton onClick={this.handleValuables}>
                                <DiamondIcon />
                                Manage Valuables...
                            </PrimaryButton>
                        </Fragment>
                    ) : (
                        <PrimaryButton disabled={locked} onClick={this.handleValuables}>
                            <DiamondIcon />
                            Add Valuables...
                        </PrimaryButton>
                    )}
                </InlineField>
            </Grid>
        );
    }

    renderPhotos() {
        const { form, classes } = this.props;
        const photos = form.getField('DeceasedPhotos') || [];
        const refPhoto = form.getField('ReferencePhoto') || [];
        const refPhotoID = refPhoto && refPhoto.ID;
        return (
            <Grid bucket={true} container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>Reference Photos</span>
                    </Typography>

                    {photos.length > 0 ? (
                        <ImageList>
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID === photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            title={'Mortuary Reference Photo'}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name,
                                                tileWidth: 2,
                                                tileHeight: 2
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID !== photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                        </ImageList>
                    ) : (
                        <Typography variant="subheading">No photos supplied.</Typography>
                    )}
                </Grid>
                <Grid pc={1}>
                    <UploadFile
                        label={'Upload Image'}
                        accept={'image/*'}
                        folderPath={`/documents/funeral/${form.getField('ID')}`}
                        onComplete={({ uploadFile }) => this.onFileUploaded(uploadFile)}
                    />
                </Grid>
            </Grid>
        );
    }
}

const TransferActionsFragment = buildTabDataFragment(
    [
        gql`
            fragment TransferActions on Funeral {
                ID
                LegacyKey
                Cancelled
                FirstName
                MiddleName
                Surname
                Gender
                DateOfDeath1
                DateOfDeath2
                DateOfDeathType
                Age
                AgeCode
                DateOfService

                Disposal {
                    ID
                    CrematedOrBuried
                    Date
                    Time
                    Start
                    LocationFlattened
                    Location {
                        ID
                        Name
                    }
                }

                ValuableItems {
                    ID
                    Description
                    Quantity
                    ToBePlaced
                    CurrentLocation
                    CurrentLocationDetail
                    WhereToBeReturned
                    ToBeReturned
                    FinalAction
                    Signed
                    Note
                }

                PlaceOfService {
                    ID
                    Date
                    Time
                    Start
                    Type
                    LocationFlattened
                    Location {
                        ID
                        Name
                    }
                }

                DeceasedPhotos {
                    ... on File {
                        ID
                        AbsoluteLink
                        Name
                    }
                    ... on Image {
                        ID
                        AbsoluteLink
                        Name
                    }
                }

                Arrangers {
                    ID
                    Member {
                        ID
                        FirstName
                        Surname
                    }
                }

                Coordinators {
                    ID
                    Member {
                        ID
                        FirstName
                        Surname
                    }
                }
            }
        `,
        ReferencePhoto
    ],
    'Funeral'
);

const styles = ({ spacing, typography, palette, breakpoints, funeralHome }) => ({
    paper: {
        padding: `${spacing(3)} ${spacing(1)}`,
        width: '100%',
        [breakpoints.down('md')]: {
            padding: `${spacing(3)} 0`
        }
    },
    pageTitle: {
        color: palette.contentForeground[funeralHome]
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.action.active,
        color: palette.text.primary
    },
    memberIcons: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: spacing(1),
        columnGap: spacing(1)
    },
    icon: {
        height: '24px',
        width: '24px',
        '& > span > svg': { height: '18px', width: '18px' },
        verticalAlign: 'middle'
    },
    listItems: {
        backgroundColor: 'white',
        border: `1px solid ${palette.divider}`,
        borderRadius: 16,
        padding: '4px 10px',
        margin: 2,
        float: 'left',
        whiteSpace: 'pre-line',
        position: 'relative'
    },
    colSm: {
        width: 1,
        whiteSpace: 'nowrap'
    },
    itemQty: {
        background: `${palette.divider}`,
        borderRadius: '0 10px 10px 0',
        margin: '0 -4px 0 4px',
        padding: '0px 5px',
        display: 'inline-block',
        fontWeight: 500
    },
    itemSigned: {
        margin: '-1px 8px -8px -6px',
        float: 'left',
        '& svg': {
            borderRadius: 48,
            height: 24,
            width: 24
        }
    },
    iconGood: {
        color: '#54be82',
        background: '#e9faf0'
    },
    iconBad: {
        color: '#ea5d5d',
        background: '#fdebeb'
    },
    iconMissing: {
        color: '#6eb9f7',
        background: '#ebf6fd'
    }
});
const StyledComponent = compose(withRouter, withSnackbarMessage, withStyles(styles))(TransfersActions);
const Tabs = [
    {
        id: 'TransfersActions',
        label: 'Transfer Actions',
        component: StyledComponent,
        fragment: TransferActionsFragment,
        onLoad: data => {
            flattenConnection(data, 'Transfers');
            flattenConnection(data, 'ValuableItems');
            if (Array.isArray(data.Transfers)) {
                data.Transfers.forEach(obj => flattenConnection(obj, 'AssignedStaff'));
            }
        },
        formatSaveData: (saveData, state, original) => {
            if (saveData.Transfers) {
                saveData.Transfers = state.Transfers.map(was => {
                    const obj = { ...was };
                    obj.AssignedStaff = was.AssignedStaff.map(me => ({ ID: me.ID }));
                    return obj;
                });
            }
            if (saveData.DeceasedPhotos) {
                saveData.DeceasedPhotos = saveData.DeceasedPhotos.map(({ ID }) => ({ ID }));
            }
            if (!isNullOrUndefined(saveData.ValuableItems)) {
                delete saveData.ValuableItems; // saved elsewhere
            }
        }
    }
];

class TransferActionView extends Component {
    render() {
        return (
            <GatedComponent isEnabledCode={'FM_ACCESS_Transfers_View'}>
                {isEnabled => (
                    <DataFormView
                        tabs={Tabs}
                        createNew={false}
                        createNewFunc={null}
                        objectType="Funeral"
                        itemId={this.props.match.params.id}
                        name="TransferActions"
                        context={this}
                        readOnly={!isEnabled}
                    />
                )}
            </GatedComponent>
        );
    }
}

export default withErrorBoundary(compose(withRouter, withStyles(styles))(TransferActionView), {
    fallback: ErrorFallback
});
